<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-body-1" align="left">
          {{ componentData.description }}
          <span class="primary--text">{{ signupEmail }}</span>
          {{ componentData.description1 }}
        </div>
        <div class="py-4"></div>
        <div class="text-body-1" align="left">
          {{ componentData.description2 }}
        </div>
        <div class="text-body-1" align="left">
          {{ componentData.description3 }}
        </div>
      </v-col>
      <v-col>
        <div class="py-1"></div>
        <v-alert
          :value="componentData.sendAlert"
          dense
          text
          type="success"
          icon="mdi-check-circle-outline"
          transition="slide-y-transition"
          align="left"
        >
          {{ componentData.sendSuccess }}
        </v-alert>

        <v-alert
          :value="componentData.errorAlert"
          dense
          text
          type="error"
          icon="mdi-check-circle-outline"
          transition="slide-y-transition"
          align="left"
        >
          {{ componentData.sendFail }}
        </v-alert>

        <v-btn
          block
          large
          outlined
          color="primary"
          :loading="componentData.loading"
          @click="ReSendEmail()"
        >
          <span class="mx-2 text-capitalize">{{
            componentData.reSendVerifyEmail
          }}</span>
        </v-btn>
        <div class="py-4"></div>

        <div>
          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1"
            plain
            @click="GoSignIn()"
          >
            {{ componentData.backSignin }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Mail_SendConfirmMail } from "@/apis/api";

export default {
  name: "VerifyEmail",
  props: {
    userEmail: String,
  },
  data() {
    return {
      componentData: {
        title: "信箱驗證",
        description: "小芋頭已寄出一封驗證信至「",
        description1: "」，請至該信箱內收信，並點擊信中連結完成驗證。",
        description2: "未收到信件?",
        description3: "請至「垃圾信件」中查找，或點擊重新寄送。",

        reSendVerifyEmail: "重新寄送驗證信",
        backSignin: "返回註冊",
        sendSuccess: "發送成功",
        sendFail: "發送失敗，請聯絡相關人員，將為您服務",
        sendAlert: false,
        errorAlert: false,
        loading: false,
        signupEmail: "",
      },
    };
  },
  created() {
    // 抓signup時輸入的email
    this.signupEmail = localStorage.getItem("signupEmail");
  },
  methods: {
    // 重新寄送
    ReSendEmail() {
      this.componentData.loading = true;
      this.componentData.sendAlert = false;

      let data = {
        email: this.signupEmail,
        communityID: this.$route.query.cmid,
        InviterEmail: this.$route.query.ivtem,
        // 跟第一次寄的一樣帶推薦碼（以前重寄沒帶）；對話框裡網址上不一定有 refc
        ReferralCode: this.$route.query.refc || localStorage.getItem("referral_code") || undefined,
      };

      Mail_SendConfirmMail(data)
        .then((res) => {
          console.log(res.data.message);
          this.componentData.loading = false;
          // 成功跳alert
          this.componentData.sendAlert = true;
        })
        .catch((err) => {
          console.log(err);
          this.componentData.loading = false;
          // 跳失敗alert
          this.componentData.errorAlert = true;
        });
    },
    GoSignIn() {
      this.$emit("switch", "SignUp");
    },
  },
};
</script>
